import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M11 9.5C11 8.94772 10.5523 8.5 10 8.5C9.44772 8.5 9 8.94772 9 9.5H10H11ZM9 13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13H10H9ZM10 9.5H9V13H10H11V9.5H10ZM10 16V15C7.23858 15 5 12.7614 5 10H4H3C3 13.866 6.13401 17 10 17V16ZM16 10H15C15 12.7614 12.7614 15 10 15V16V17C13.866 17 17 13.866 17 10H16ZM10 4V5C12.7614 5 15 7.23858 15 10H16H17C17 6.13401 13.866 3 10 3V4ZM10 4V3C6.13401 3 3 6.13401 3 10H4H5C5 7.23858 7.23858 5 10 5V4Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 8C9.72698 8 9.49206 7.90331 9.29524 7.70992C9.09841 7.51315 9 7.27735 9 7.00254C9 6.72434 9.09841 6.48855 9.29524 6.29516C9.49206 6.09839 9.72698 6 10 6C10.2762 6 10.5111 6.09839 10.7048 6.29516C10.9016 6.48855 11 6.72434 11 7.00254C11 7.27735 10.9016 7.51315 10.7048 7.70992C10.5111 7.90331 10.2762 8 10 8Z",
		fill: "currentColor"
	})] })
});
export default SvgInfo;
